import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { ActivityVariantEntity } from './types';
import { getEndpoint } from 'app/utils/service';

export class ActivityVariantService {

    /** It gets all ActivityVariant. */
    async getActivityVariants(options: IListFilter): Promise<ResponseBase<ResponseListBase<ActivityVariantEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-variant/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific ActivityVariant by ActivityVariant id */
    async getActivityVariant(id: string, language: string): Promise<ResponseBase<ResponseContentBase<ActivityVariantEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-variant/') + id + `?language=${language || "en"}`);
    }

    /** It creates ActivityVariant by request */
    async createActivityVariant(request: ActivityVariantEntity): Promise<ResponseBase<ResponseContentBase<ActivityVariantEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/activity-variant/'), request);
    }

    /** It publishes ActivityVariant by activity id */
    async publishActivityVariantByActivity(activityId: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().post(getEndpoint('/activity-variant/publish-by-activity'), { activityId });
    }

    /** It publishes ActivityVariant by activity id */
    async publishActivityVariant(activityVariantList: string[]): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().post(getEndpoint('/activity-variant/publish'), { activityVariantList });
    }

    /** It updates spesific ActivityVariant by id */
    async updateActivityVariant(request: ActivityVariantEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/activity-variant/') + request.id, request);
    }

    /** It deletes spesific ActivityVariant by id */
    async deleteActivityVariant(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/activity-variant/') + id);
    }
}
